import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import jwt_decode from 'jwt-decode';
// Components
import LoadingOverlay from 'components/common/LoadingOverlay';
import CustomButton from 'components/common/CustomButton';
import AssignOrderModal from './AssignOrderModal';
import NotDoneModal from './NotDoneModal';
import QualityCheckConfirmModal from 'components/common/QualityCheckConfirmModal';
// Helpers
import { hasPermission, status } from 'constants/Helpers';
// API
import TimeSlotsService from 'services/TimeSlotsService';
// Selectors
import { getPermissionsData } from 'store/app/AppSelectors';
// Localstorage
import { getFromLocalStorage } from 'helpers/LocalStorage';

const ChangeStatusBtn = ({
  item,
  initialParams,
  fetchMoreData,
  details,
  fetchFlorists,
  showAllCTA,
  hasSubmittedBefore,
  hasDeviation,
}) => {
  const [isLoaderOpen, setIsloaderOpen] = useState(false);
  const [isModalOpen, setIsOpenModal] = useState(false);
  const [isQualityCheckModalOpen, setIsQualityCheckModalOpen] = useState(false);
  const [isNotDoneModalOpen, setIsNotDoneModalOpen] = useState(false);
  const [isProductionOfficer, setIsProductionOfficer] = useState(false);
  const permissions = useSelector((state) => getPermissionsData({ state }));
  const deviationEnabled = true;
  const isQualityCheckEnabled = true;
  const location = useLocation();
  const currentPage = location.pathname.slice(1);
  const navigate = useNavigate();

  const fetchData = () => {
    if (details) {
      fetchMoreData(item?.id);
    } else {
      fetchMoreData(initialParams, 1);
      if (fetchFlorists) {
        fetchFlorists();
      }
    }
  };

  const handleChangeStatus = async (item) => {
    setIsloaderOpen(true);
    try {
      if (item?.status === 3 || item?.status === 7) {
        await TimeSlotsService.getChangeProdiuctionStatus({ Status: 2 }, item?.id);
        setTimeout(() => fetchData(), 1000);
      } else if (item?.status === 2) {
        if (isQualityCheckEnabled) {
          setIsQualityCheckModalOpen(true);
        } else {
          await TimeSlotsService.getChangeProdiuctionStatus({ Status: 0 }, item?.id);
          setTimeout(() => fetchData(), 500);
        }
      } else if (!item?.status || item?.status === 6 || item?.status === 1) {
        if (isProductionOfficer) {
          setIsOpenModal(true);
        } else {
          await TimeSlotsService.getAssignProdiuction(
            {
              assigneeId:
                getFromLocalStorage('floristId') ?? jwt_decode(getFromLocalStorage('token'))?.id,
            },
            item?.id
          );
          setTimeout(() => fetchData(), 1000);
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message ?? 'Status change failed!');
      setIsloaderOpen(false);
    }
    setIsloaderOpen(false);
  };

  const isSubmitted = (productId, productionId) => {
    return hasSubmittedBefore?.filter(
      (sb) => sb?.productId === productId && sb?.productionId === productionId
    )?.[0]?.hasSubmittedBefore;
  };

  const isDoneDisable = (s) => {
    if (s === 'Done' && deviationEnabled && currentPage === 'orders') {
      return true;
    } else {
      if (hasSubmittedBefore !== null && hasDeviation !== null) {
        let disableBtn = false;
        hasDeviation?.forEach((d) => {
          if (d?.hasDeviation && !isSubmitted(d?.productId, d?.productionId)) {
            disableBtn = true;
          }
        });
        return s === 'Done' && disableBtn;
      } else {
        return false;
      }
    }
  };

  useEffect(() => {
    setIsProductionOfficer(hasPermission(permissions, 'florist_orders', 'head_assign'));
  }, [permissions]);

  return (
    <>
      {isLoaderOpen && <LoadingOverlay />}
      {isQualityCheckModalOpen && (
        <QualityCheckConfirmModal
          handleCancelClick={() => setIsQualityCheckModalOpen(false)}
          handleProceedClick={() => navigate(`/qualitycheck-pj/${item?.id}`)}
          message={'Please proceed to complete Quality Check!'}
          isOpen={isQualityCheckModalOpen}
          setIsOpen={setIsQualityCheckModalOpen}
          cancelBtnName="Cancel"
        />
      )}
      {isModalOpen && (
        <AssignOrderModal
          isModalOpen={isModalOpen}
          setIsOpenModal={setIsOpenModal}
          orderData={item}
          fetchData={fetchData}
        />
      )}
      {isNotDoneModalOpen && (
        <NotDoneModal
          isModalOpen={isNotDoneModalOpen}
          setIsOpenModal={setIsNotDoneModalOpen}
          orderData={item}
          fetchData={fetchData}
        />
      )}
      {showAllCTA ? (
        typeof status[item?.status ?? 6] === 'string' ? (
          <CustomButton
            handleClick={() => handleChangeStatus(item)}
            type={`status ${item?.status === 0 ? 'success hidden' : 'primary'}`}
            disabled={item?.status === 4}
            name={status[item?.status ?? 6]}
          />
        ) : Array.isArray(status[item?.status ?? 6]) ? (
          status[item?.status ?? 6]?.map((s) => {
            return (
              <CustomButton
                handleClick={
                  s === 'Done' ? () => handleChangeStatus(item) : () => setIsNotDoneModalOpen(true)
                }
                type={`status ${s === 'Done' ? 'success' : 'danger'} ${
                  item?.status === 0 ? 'hidden' : ''
                }`}
                name={s}
                key={s}
                disabled={
                  isDoneDisable(s) ||
                  (s === 'Done' &&
                    hasDeviation?.some((el) => el.hasDeviation) &&
                    !item?.reviewStatus)
                }
              />
            );
          })
        ) : (
          <CustomButton
            handleClick={() => handleChangeStatus(item)}
            type={`status secondary ${item?.status === 0 ? 'hidden' : ''}`}
            disabled={!status[item?.status ?? 6].enabled}
            name={status[item?.status ?? 6].text}
          />
        )
      ) : (
        <CustomButton
          handleClick={() => handleChangeStatus(item)}
          type="status primary"
          disabled={[0, 2, 3, 4, 5, 7, 8].includes(item?.status)}
          name={status[1]}
        />
      )}
    </>
  );
};

export default ChangeStatusBtn;
